class Error {
    constructor(status, message, description) {
        this.status = status;
        this.message = message;
        this.description = description;
    }
}

class API {
    constructor(token) {
        this.token = token;
    }

    _getHeaders() {
        return {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization" : "Bearer "+this.token
            }
        }
    }
}

export {
    Error, API,
};